import { render, staticRenderFns } from "./IconFacebook.vue?vue&type=template&id=fda6b1e8&"
import script from "./IconFacebook.vue?vue&type=script&lang=js&"
export * from "./IconFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fda6b1e8')) {
      api.createRecord('fda6b1e8', component.options)
    } else {
      api.reload('fda6b1e8', component.options)
    }
    module.hot.accept("./IconFacebook.vue?vue&type=template&id=fda6b1e8&", function () {
      api.rerender('fda6b1e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconFacebook.vue"
export default component.exports